<template>
  <div class="snow-canvas-wrapper">
    <canvas id="snowCanvas"></canvas>
  </div>
</template>

<style scoped>
.snow-canvas-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}

#snowCanvas {
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  name: "SnowEffect",
  mounted() {
    const canvas = document.getElementById("snowCanvas");
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const snowflakes = [];
    // تعداد برف‌ها برای تعادل بیشتر به 90 افزایش یافت
    let numFlakes = 150;
    console.log(window.innerWidth, "window.innerWidth");

    if (window.innerWidth < 1000) {
      numFlakes = 50;
    } else {
      numFlakes = 120;
    }

    class Snowflake {
      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 3 + 1.5; // اندازه پایه
        this.speed = Math.random() * 1.0 + 0.5;
        this.opacity = Math.random() * 0.6 + 0.4;
        this.angle = Math.random() * Math.PI * 2;
        this.spinSpeed = (Math.random() - 0.5) * 0.015;

        // توزیع نوع:
        // 0: چندضلعی (کوچکتر و کمتر) - حدود 30%
        // 1: ستاره‌ای (بزرگتر و بیشتر) - حدود 70%
        this.type = Math.random() < 0.3 ? 0 : 1;
      }

      update() {
        this.y += this.speed;
        this.x += Math.sin(this.angle) * 0.4;
        this.angle += this.spinSpeed;
        if (this.y > canvas.height) this.reset();
      }

      draw() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.globalAlpha = this.opacity;

        const color = "#eb6fa7";
        ctx.strokeStyle = color;
        ctx.fillStyle = color;

        if (this.type === 0) {
          // **نوع 0: چندضلعی (کوچک و کم)**

          // اعمال اندازه کوچکتر برای چندضلعی‌ها
          const smallRadius = this.size * 1.5;

          const sides = Math.floor(Math.random() * 3) + 5; // بین 5 تا 7 ضلع
          ctx.beginPath();
          for (let i = 0; i < sides; i++) {
            const theta = (i / sides) * Math.PI * 2;
            const r = smallRadius * (0.9 + Math.random() * 0.1);
            ctx.lineTo(Math.cos(theta) * r, Math.sin(theta) * r);
          }
          ctx.closePath();
          ctx.fill();
        } else {
          // **نوع 1: ستاره شکل (شبیه 6 ضلعی، بیشتر و با اندازه نرمال)**
          const radius = this.size * 2; // اندازه نرمال/بزرگتر

          ctx.beginPath();
          for (let i = 0; i < 6; i++) {
            const theta = (i / 6) * Math.PI * 2;
            ctx.moveTo(0, 0);
            ctx.lineWidth = 1.5;
            ctx.lineTo(
              Math.cos(theta) * radius * 0.9,
              Math.sin(theta) * radius * 0.9
            );
          }
          ctx.stroke();
        }

        ctx.restore();
      }
    }

    for (let i = 0; i < numFlakes; i++) {
      snowflakes.push(new Snowflake());
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      snowflakes.forEach((flake) => {
        flake.update();
        flake.draw();
      });
      requestAnimationFrame(animate);
    }

    animate();

    window.addEventListener("resize", () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  },
};
</script>
